/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';

import { useParseDates } from '../../hooks/useDates';

import styles from '../../../styles/partials/date-range.module.scss';

const propTypes = {
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    startPrefix: PropTypes.node,
    endPrefix: PropTypes.node,
    className: PropTypes.string,
    startDateClassName: PropTypes.string,
    endDateClassName: PropTypes.string,
};

const defaultProps = {
    startDate: null,
    endDate: null,
    startPrefix: null,
    endPrefix: null,
    startDateClassName: null,
    endDateClassName: null,
    className: null,
};

const DateRange = ({
    startDate: initialStartDate,
    endDate: initialEndDate,
    startPrefix,
    endPrefix,
    className,
    startDateClassName,
    endDateClassName,
}) => {
    const { startDate, endDate } = useParseDates(initialStartDate, initialEndDate);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div
                className={classNames([
                    styles.startDate,
                    {
                        [startDateClassName]: startDateClassName !== null,
                    },
                ])}
            >
                {startPrefix !== null ? startPrefix : null}{' '}
                <FormattedDate
                    value={startDate}
                    year="numeric"
                    month="long"
                    day="numeric"
                    weekday="long"
                />
                {' - '}
                <FormattedTime value={startDate} />
            </div>

            {endDate !== null ? (
                <div
                    className={classNames([
                        styles.endDate,
                        {
                            [endDateClassName]: endDateClassName !== null,
                        },
                    ])}
                >
                    {endPrefix !== null ? endPrefix : null}{' '}
                    <FormattedDate
                        value={endDate}
                        year="numeric"
                        month="long"
                        day="numeric"
                        weekday="long"
                    />
                    {' - '}
                    <FormattedTime value={endDate} />
                </div>
            ) : null}
        </div>
    );
};

DateRange.propTypes = propTypes;
DateRange.defaultProps = defaultProps;

export default DateRange;
